/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedTabularProductDataListDto } from '../../models/backend-paginated-tabular-product-data-list-dto';

export interface SalesTabularProductsDataList$Params {
  id: number;

  /**
   * Number of results to return per page.
   */
  limit?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export function salesTabularProductsDataList(
  http: HttpClient,
  rootUrl: string,
  params: SalesTabularProductsDataList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedTabularProductDataListDto>> {
  const rb = new RequestBuilder(rootUrl, salesTabularProductsDataList.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedTabularProductDataListDto>;
    }),
  );
}

salesTabularProductsDataList.PATH = '/api/sales/tabular-products-data/{id}/';
